import { useCallback, useEffect, useState } from 'react'
import L from 'leaflet'
import {
    deleteMapLayer,
    isAlreadyMapLayerAdded
} from '../../../utils/floor-plan-layer'

const initState = []

export const useReportsHeatmap = (
    heatmapData,
    map,
    floorPlanId,
    isSelectedReports = true
) => {
    const [reportsHeatmapPoints, setReportsHeatmapPoints] = useState(initState)

    useEffect(() => {
        if (heatmapData) {
            // test shortcut (comment createHeatmapPoints() when uncommenting this):
            // setReportsHeatmapPoints([
            //     [-200, -200],
            //     [-200, -200],
            //     [-200, -200],
            //     [600, 600],
            //     [900, 900],
            //     [900, 900],
            //     [900, 900],
            //     [900, 900],
            //     [900, 900],
            //     [900, 900],
            //     [900, 900],
            //     [900, 900],
            //     [900, 900],
            //     [900, 900],
            //     [900, 900],
            //     [900, 900],
            //     [300, 300],
            //     [300, 300],
            //     [300, 300]
            // ])
            const heatmapPoints = calculateCoordinates(heatmapData, floorPlanId)
            setReportsHeatmapPoints(heatmapPoints)

            if (isAlreadyMapLayerAdded(map) && isSelectedReports) {
                reloadReportsHeatmap(heatmapPoints)
            }
        }
    }, [heatmapData, floorPlanId])

    const addReportsHeatmap = useCallback(() => {
        if (!map) return
        createMapLayer(reportsHeatmapPoints).addTo(map)
    }, [reportsHeatmapPoints, map])

    const createMapLayer = reportsHeatmapPoints => {
        return L.heatLayer(reportsHeatmapPoints, {
            radius: 25,
            blur: 15,
            minOpacity: 0.8,
            maxZoom: 3
        })
    }

    const calculateCoordinates = (data, floorPlanId) => {
        return data
            .map(d => {
                const coordinates = d.floor_plans[floorPlanId]?.coordinates
                return coordinates ? [coordinates.lat, coordinates.lng] : null
            })
            .filter(point => point !== null)
    }

    const reloadReportsHeatmap = useCallback(
        reportsHeatmapPoints => {
            if (!map) return
            deleteMapLayer(map)
            createMapLayer(reportsHeatmapPoints).addTo(map)
        },
        [map]
    )

    return { addReportsHeatmap }
}
